import React, { lazy, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
// import "moment/locale/es";
// import moment from "moment";
import Layout from "./components/layouts/Layout";
import { useSearchParams } from "react-router-dom";
//import Mantenimiento from "./pages/lineanueva/mantenimiento";
const DatosLN = lazy(() => import("./pages/datos"));
const EntregaSimLN = lazy(() => import("./pages/entregasim"));
const Gracias = lazy(() => import("./pages/gracias"));

function App() {
  // moment.locale("es");
  /*   const currentDate = moment(); // Obtener la fecha y hora actual

  // Definir las fechas y horas límite para el mantenimiento
  const maintenanceStartDate = moment("2023-07-15 20:00", "YYYY-MM-DD HH:mm");
  const maintenanceEndDate = moment("2023-07-16 08:00", "YYYY-MM-DD HH:mm");

  // Verificar si la fecha actual está dentro del rango de mantenimiento
  const shouldShowMaintenance =
    currentDate.isSameOrAfter(maintenanceStartDate) &&
    currentDate.isBefore(maintenanceEndDate); */
  /* 
  if (true) {
    return <Mantenimiento />;
  }
*/
  const [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    if (!searchParams.get("offeringId")) {
      window.location.replace(`${process.env.REACT_APP_URL_PREPAGO}/portabilidad-prepago`);
    }
  }, []);
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<DatosLN />} />
        <Route path="entregasim" element={<EntregaSimLN />} />
		    <Route path="/gracias" element={<Gracias />} />
      </Route>
    </Routes>
  );
}

export default App;
